// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"wrapper-EHnsM","context":"context-3SXCy","icon":"icon-2-NBv","text":"text-2bwQZ"};